<template>
  <div>
    <b-card
      class="border-primary-lighter mt-4 pt-3 pl-3 pr-3 custom-checklist"
      v-for="(checklist, checklistIndex) in checklists"
      :key="checklist.id"
      no-body
    >
      <b-card-body class="px-3 pt-3 pb-3">
        <div
          class="d-flex align-items-center justify-content-between mb-4 checklist-title-wrapper"
        >
          <b-form-input
            @keypress.enter="saveChecklistTitle(checklistIndex)"
            type="text"
            :disabled="!isFormEnabled"
            autofocus
            v-if="checklist.isEditingTitle"
            class="checklist-title-input"
            v-model="newChecklistTitle"
            placeholder="Add checklist title"
          >
          </b-form-input>
          <h6
            class="font-sm primary--text font-family-medium font-size-md mb-0 checklist-title"
            v-else
            @click="editChecklistTitle(checklistIndex)"
          >
            {{ checklist.title }}
          </h6>
          <b-button
            data-cy="delete-checklist-btn"
            class="btn-pill btn-danger px-4 attachment-delete-btn"
            :disabled="!isFormEnabled"
            @click="showDeleteChecklistModal(checklistIndex)"
          >
            Delete
          </b-button>
        </div>
        <div class="checklist-options-container">
          <Container
            @drop="onItemDrop(checklist, $event)"
            @drag-start="onDragStart"
            @drag-end="onDragEnd"
            non-drag-area-selector=".drag-disabled"
          >
            <Draggable
              v-for="(option, index) in checklist.options"
              :key="index"
            >
              <div
                :class="{
                  'checklist-option-container': true,
                  'drag-disabled': option.isEditing || !isFormEnabled,
                  editing: option.isEditing
                }"
              >
                <template v-if="!option.isEditing">
                  <b-form-checkbox
                    size="lg"
                    class="checkbox checkbox-title-container"
                    name="check"
                    :disabled="!isFormEnabled || checkboxDisabled"
                    v-model="option.isChecked"
                    @change="saveChecklistOption(checklistIndex, index, false)"
                  ></b-form-checkbox>
                  <p
                    @click="showChecklistOptionEditBox(checklistIndex, option)"
                    class="primary--text"
                  >
                    {{ option.title }}
                  </p>
                  <div 
                  class="close-wrapper"
                  
                  >
                    <img
                      data-cy="remove-checklist-option"
                      class="cursor-pointer remove-option-icon"
                      @click="
                        isFormEnabled
                          ? removeOption(checklistIndex, index)
                          : null
                      "
                      src="@/assets/icons/checklist_close.svg"
                      alt=""
                    />
                  </div>
                </template>
                <template v-else>
                  <div class="checklist-option-input-wrapper">
                    <b-form-textarea
                      @keypress.enter="
                        saveChecklistOption(checklistIndex, index)
                      "
                      type="text"
                      autofocus
                      :max-rows="8"
                      :rows="1"
                      size="sm"
                      :style="{ overflowY: 'auto' }"
                      v-model="checklist.options[index].title"
                      v-if="option.isEditing"
                      class="checklist-option-input"
                      placeholder="Add a checklist option"
                    >
                    </b-form-textarea>
                  </div>
                </template>
              </div>
            </Draggable>
          </Container>
          <div
            class="checklist-option-input-wrapper checklist-new-option-box"
            v-if="checklist.showNewOptionBox"
          >
            <b-form-textarea
              @keypress.enter.prevent="saveChecklistOption(checklistIndex, null, true)"
              type="text"
              autofocus
              :max-rows="8"
              :rows="1"
              :style="{ overflowY: 'auto' }"
              size="sm"
              v-model="newChecklistOption"
              class="checklist-option-input"
              placeholder="Add a checklist option"
            >
            </b-form-textarea>
          </div>
          <div class="add-button-wrapper">
            <b-button
              data-cy="add-checklist-option-btn"
              @click="onAddChecklistOption(checklistIndex)"
              class="btn-pill px-4"
              :disabled="!isFormEnabled"
              >+ Add
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-modal
      id="delete-checklist-modal"
      v-model="deleteModal.visible"
      body-class="delete-checklist-modal-body"
      hide-header
      hide-footer
      centered
    >
      <h1 class="font-lg">Are you sure?</h1>
      <h3 class="font-lg">Do you want to delete the checklist?</h3>
      <div class="buttons-row">
        <div class="buttons-wrapper">
          <div class="button-wrapper">
            <b-button class="cancel-button" @click="deleteModal.visible = false"
              >Cancel</b-button
            >
          </div>
          <div class="button-wrapper">
            <b-button
              class="delete-button"
              @click="deleteChecklist(deleteModal.checklistIndex)"
              >Confirm Delete</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import {
  updateChecklistItemPositions,
  onChecklistItemDrop,
  onDragStart,
  onDragEnd
} from "@/utils/checklistDndUtils";
export default {
  name: "ChecklistComponent",
  components: {
    Draggable,
    Container
  },
  data() {
    return {
      newChecklistOption: "",
      newChecklistTitle: "",
      deleteModal: {
        visible: false,
        checklistIndex: null
      }
    };
  },
  props: ["checklists", "isFormEnabled", "checkboxDisabled"],
  mounted() {
    console.log(this.isFormEnabled);
  },
  computed: {
    disableChecklistOptionAdd() {
      return this.checklists.some(checklist => {
        return checklist.showNewOptionBox;
      });
    }
  },
  methods: {
    onDragStart,
    onDragEnd,
    onItemDrop(checklist, dragResult) {
      onChecklistItemDrop(checklist, dragResult);
      this.$emit("updateChecklist", checklist, this.deleteModal);
    },
    updateChecklistItemPositions,
    onAddChecklistOption(checklistIndex) {
      let checklist = this.checklists[checklistIndex];
      this.closeAllChecklistEditBoxes();
      this.$set(checklist, "showNewOptionBox", true);
      this.$emit("addChecklistOption", this.deleteModal);
    },
    closeAllChecklistEditBoxes() {
      if (this.checklists.length) {
        this.checklists.forEach(checklist => {
          this.$set(checklist, "isEditingTitle", false);
          this.$set(checklist, "showNewOptionBox", false);
          checklist.options && checklist.options.forEach(option => {
            this.$set(option, "isEditing", false);
          });
        });
        this.newChecklistOption = "";
      }
    },
    saveChecklistOption(checklistIndex, optionIndex, isNewOption) {
      this.$emit(
        "saveOption",
        this.newChecklistOption,
        checklistIndex,
        optionIndex,
        isNewOption,
        this.deleteModal
      );
      isNewOption && this.onAddChecklistOption(checklistIndex);
    },
    saveChecklistTitle(index) {
      this.$emit("saveTitle", index, this.newChecklistTitle, this.deleteModal);
      let checklist = this.checklists[index];
      this.$set(checklist, "isEditingTitle", false);
    },
    editChecklistTitle(index) {
      if (this.isFormEnabled) {
        let checklist = this.checklists[index];
        this.newChecklistTitle = checklist.title;
        this.closeAllChecklistEditBoxes();
        this.$set(checklist, "isEditingTitle", true);
        this.$emit("editChecklistTitle", this.deleteModal);
      }
    },
    showDeleteChecklistModal(checklistIndex) {
      this.deleteModal.checklistIndex = checklistIndex;
      this.deleteModal.visible = true;
    },
    deleteChecklist(index) {
      this.$emit("deleteChecklist", index, this.deleteModal);
      this.deleteModal.visible = false;
    },
    removeOption(checklistIndex, index) {
      this.$emit("deleteOption", checklistIndex, index, this.deleteModal);
    },
    showChecklistOptionEditBox(checklistIndex, option) {
      if (this.isFormEnabled) {
        // close all the edit boxes. For safety's sake, let's only keep one edit box open at a time
        this.closeAllChecklistEditBoxes();
        this.newChecklistOption = option.title;
        this.$set(option, "isEditing", true);
        this.$emit("editChecklistOption", this.deleteModal);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.preferences-card-wrapper {
  margin-bottom: 5rem;
  padding-right: 1.5rem;
}
.preferences-categories-card {
  border-radius: 10px;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
  // border: 1px solid #dcebf4 !important;
}
.tasks-attachment-card {
  width: inherit;
  border: 1px solid #dcebf4 !important;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.high-priority-text {
  margin: 2px;
}
.tasks-form-card {
  height: 4rem;
}
.comment-card-body {
  width: 30rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-running-container p {
  // line-height: 1.8rem !important;
  color: #784f89;
  top: 1.3rem;
}

.checkbox-title-container {
  z-index: 0;
  top: 0.2rem;
}

.attachment-name {
  font-size: 1.5rem !important;
}

.show-timer p {
  top: 1.2rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checklist-options-container {
  // height: 3rem;
  margin-bottom: 2.4rem;
}

.tasks-dropdown-divider {
  margin-top: 2.5rem;
}

.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  // max-width: 21.66%;
  // flex: 0 0 21.66%;
  // width: 21.6%;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  border-radius: 6px;
  // padding: 2rem;
  width: 15rem;
}

.show-timer-container {
  margin-top: -6rem;
}

.box-container a {
  opacity: 0.3;
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.carousel-outer-container p {
  margin-top: 1rem;
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
.tasks-textarea {
  min-height: 17rem !important;
}
.status-field {
  margin-top: 40px;
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.checklist-option-input-wrapper {
  flex: 1;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.save-button-row {
  padding-left: 30px;
  .save-button {
    background: $button-secondary;
  }
}
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
</style>
